/**
 * build.ts — identita běžícího UI buildu (pro detekci stale cache po deployi).
 *
 * RUNNING_UI_BUILD = hash hlavního assetu, který si tenhle tab reálně načetl
 * (`/assets/index-<hash>.js`). Server hlásí aktuální build v /api/server-info
 * (ui_build); když se liší, běží stará cache → AppLayout nabídne obnovení.
 *
 * Cookie `acm_ui_build` nese build, ke kterému se váže načtená cache (dle přání
 * — čitelné i mimo JS, přežije reload). Není to auth cookie, jen marker verze.
 */
export const RUNNING_UI_BUILD: string = (() => {
  try {
    const s = document.querySelector(
      'script[type="module"][src*="/assets/index-"]',
    ) as HTMLScriptElement | null;
    const m = s?.src.match(/index-([A-Za-z0-9_-]+)\.js/);
    return m?.[1] ?? '';
  } catch {
    return '';
  }
})();

try {
  if (RUNNING_UI_BUILD) {
    document.cookie =
      `acm_ui_build=${RUNNING_UI_BUILD}; path=/; max-age=31536000; samesite=lax`;
  }
} catch { /* SSR / cookie zakázané — marker prostě nebude */ }
